<nz-card nzTitle="Workcenters" class="em-area">
  <nz-skeleton [nzActive]="true" [nzLoading]="(loading$ | async) ?? false">
    <!-- Outside the error branch on purpose: changing the selection is what triggers a
         new request, so hiding it alongside the table left no way to recover. -->
    <em-workcenter-selector
      [loading]="(paginatorRef.loading$ | async) ?? false"
      (selectedPmOrders)="selectedPmOrdersChange($event)"
    ></em-workcenter-selector>

    <ng-container *ngIf="pmOperationsError$ | async as errorMsg; else resultTemplate">
      <em-error-result [subTitle]="errorMsg"></em-error-result>
    </ng-container>

    <ng-template #resultTemplate>
      <ng-container *ngIf="workcenters$ | async as workcenters">
        <nz-table
          #workcenterTableRef
          [nzData]="workcenters.data"
          [nzLoading]="(paginatorRef.loading$ | async) ?? false"
          [nzTotal]="workcenters.total ?? 0"
          nzSize="small"
          nzShowSizeChanger
          [nzFrontPagination]="false"
          [(nzPageSize)]="perPage"
          [nzPageSizeOptions]="[5, 10, 20, 30]"
          [(nzPageIndex)]="pageIndex"
          (nzPageIndexChange)="paginatorRef.setPage($event)"
          (nzPageSizeChange)="pageSizeChange($event)"
        >
          <thead>
            <tr>
              <th>Act</th>
              <th>Workcenter</th>
              <th>Order type</th>
              <th>Order priority</th>
              <th>Start Point</th>
              <th>Earliest end date</th>
              <th>Duration</th>
              <th>Date 2</th>
              <th>Latest finish</th>
              <th>Finish constraint</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of workcenterTableRef.data; trackBy: trackByRef">
              <td>{{ data.activityNumber }}</td>
              <td>{{ data.workCenter }} - {{ data?.workCenterDescription }}</td>
              <td>{{ data.order?.orderType }}</td>
              <td>{{ data.order?.priorityDescription }}</td>
              <td>{{ data.constraintStartDate | date: 'shortDate' }}</td>
              <td>{{ data.earliestFinishExecutionDate | date: 'shortDate' }}</td>
              <td>{{ data.durationOfActivity }} {{ data.durationOfActivityUnit }}</td>
              <td>{{ data.userDate09 | date: 'shortDate' }}</td>
              <td>{{ data.constraintEndDate | date: 'shortDate' }}</td>
              <td>{{ data.constraintTypeEnd }}</td>
              <td>{{ data.systemStatus }}</td>
            </tr>
          </tbody>
        </nz-table>
      </ng-container>
    </ng-template>
  </nz-skeleton>
</nz-card>
